import { PaletteOptions } from '@material-ui/core/styles/createPalette'

const palette: PaletteOptions = {
  primary: {
    main: '#5958B6', // primary 300
    dark: '#3F3D87', // primary 400
    contrastText: '#2E2972' // primary 500
  },
  secondary: {
    main: '#D7DBFF', // primary 200
    dark: '#202020' // neutral 400
  },
  background: {
    default: '#FDFDFF', // white
    paper: '#EFF1FF' // primary100
  },
  text: {
    primary: '#202020', // black
    secondary: '#FDFDFF' // white
  },
  grey: {
    100: '#ECECEC', // neutral 100
    200: '#CDCED7', // neutral 200
    300: '#8B8D98', // neutral 300
    500: '#626262' // neutral 500
  },
  error: {
    main: '#C12555' // status Error
  },
  warning: {
    main: '#EAC300' // status Pending
  },
  info: {
    main: '#4A5FC1' // status In Progress
  },
  success: {
    main: '#FF0000' // status Success
  }
}

export default palette
